import { createElement } from 'react'
import { Table } from 'shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Delete } from '../shared/local/components/deleteButton'
import { Update } from '../shared/local/components/updateButton'
import { Invoice } from '../shared/local/components/invoiceButton'

// Create common beneficiary control
export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
    maxWidth: 52,
    width: 52,
  },
  {
    Header: 'Full Name',
    accessor: 'sponsorFullName',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Sponsor limit',
    accessor: 'sponsorLimit',
  },
  {
    Header: 'Website',
    accessor: 'website',
    Cell: Table.CellRenderers.LinkCell,
  },
  {
    Header: 'Member Status',
    accessor: 'active',
    Cell: (props) => {
      return createElement(Table.CellRenderers.UserStatusCell, { ...props })
    },
  },
  {
    Header: 'Marketing Promotion',
    accessor: 'marketingPromotion',
    Cell: (props) => {
      return props.value ? 'Yes' : 'No'
    },
  },
  {
    Header: 'Update',
    id: 'controls',
    maxWidth: 110,
    accessor: (value) => value,
    Cell: (props) => createElement(Update, { ...props }),
  },
  {
    Header: 'Delete',
    id: 'controls',
    maxWidth: 130,
    accessor: (value) => value,
    Cell: (props) => createElement(Delete, { ...props }),
  },
  {
    Header: 'Invoice',
    id: 'controls',
    maxWidth: 130,
    accessor: (value) => value,
    Cell: (props) => createElement(Invoice, { ...props }),
  },
]
